import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './useAuth'
import { LoadingSpinner } from '../components/LoadingSpinner'
import styles from './GoogleCallback.module.css'

export function GoogleCallback() {
  const { loginGoogle } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const errorParam = params.get('error')

    if (errorParam || !code) {
      navigate('/login?error=google_failed', { replace: true })
      return
    }

    loginGoogle(code)
      .then(() => {
        const redirect = sessionStorage.getItem('fasico:redirect_after_login')
        sessionStorage.removeItem('fasico:redirect_after_login')
        navigate(redirect ?? '/', { replace: true })
      })
      .catch(() => {
        setError('No pudimos iniciar sesión con Google. Intenta nuevamente.')
        setTimeout(() => navigate('/login?error=google_failed', { replace: true }), 2500)
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error) {
    return (
      <div className={styles.page}>
        <p className={styles.error}>{error}</p>
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <LoadingSpinner size="lg" message="Iniciando sesión con Google..." />
    </div>
  )
}
